import { useContext } from "react";
import { UserContext } from "../context/UserContext";

export const useUserContext = () => {
  const { user, updateUser } = useContext(UserContext);
  return { user, updateUser };
};
